import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetProductBranchsList = guid => {
  const [loading, setLoading] = useState(true);
  const [branchList, setBranchList] = useState({});

  const { enqueueSnackbar } = useSnackbar();

  const getProductBranchList = ({ page, count, search }) => {
    setLoading(true);

    axiosClient
      .get(
        `Product/Origin/BranchList?Guid=${guid}&Page=${page}&Count=${count}&Term=${search}`,
      )
      .then(res => {
        if (res.status === 200) {
          setBranchList(res.data.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [getProductBranchList, loading, branchList];
};

export default useGetProductBranchsList;
